import { IconAngleRight } from '@iwoca/icons';

import { SafeLink } from '../../../../components/SafeLink/SafeLink';
import noCustomers from '../../assets/noCustomers.svg';

export const CustomersEmptyState = () => (
  <div className="flex flex-col items-center gap-l py-2xl text-center">
    <img
      src={noCustomers}
      alt=""
      // The SVG's only intrinsic size is its 360x240 viewBox.
      className="w-[360px] max-w-full"
    />
    <div className="text-m font-bold text-primary-10">
      You don’t have any customers yet
    </div>
    <div className="max-w-[320px] text-s font-reg text-primary-10">
      Once a customer creates an account through your Paylink, they’ll appear
      here.
    </div>
    <SafeLink
      to="/pay/pay-links/universal"
      className="flex items-center gap-xs text-s font-med text-primary-40"
    >
      Create a Paylink
      <IconAngleRight height={16} width={16} aria-hidden />
    </SafeLink>
  </div>
);
